export const USER_LIST_ACTIONS = {
  USER_LIST_REQUEST: "USER_LIST_REQUEST",
  USER_LIST_RESPONSE: "USER_LIST_RESPONSE",
  USER_LIST_ERROR: "USER_LIST_ERROR",
};
export const VIEW_USER_DETAIL_ACTIONS = {
  VIEW_USER_DETAIL_REQUEST: "VIEW_USER_DETAIL_REQUEST",
  VIEW_USER_DETAIL_RESPONSE: "VIEW_USER_DETAIL_RESPONSE",
  VIEW_USER_DETAIL_ERROR: "VIEW_USER_DETAIL_ERROR",
};
export const USER_DETAIL_ACTIONS = {
  USER_DETAIL_REQUEST: "USER_DETAIL_REQUEST",
  USER_DETAIL_RESPONSE: "USER_DETAIL_RESPONSE",
  USER_DETAIL_ERROR: "USER_DETAIL_ERROR",
};


export const USER_EDIT_ACTIONS = {
  USER_EDIT_REQUEST: "USER_EDIT_REQUEST",
  USER_EDIT_RESPONSE: "USER_EDIT_RESPONSE",
  USER_EDIT_ERROR: "USER_EDIT_ERROR",
};
export const USER_EDIT_DETAIL_ACTIONS = {
  USER_EDIT_DETAIL_REQUEST: "USER_EDIT_DETAIL_REQUEST",
  USER_EDIT_DETAIL_RESPONSE: "USER_EDIT_DETAIL_RESPONSE",
  USER_EDIT_DETAIL_ERROR: "USER_EDIT_DETAIL_ERROR",
};
export const USER_FOLLOWING_ACTION = {
  USER_FOLLOWING_REQUEST: "USER_FOLLOWING_REQUEST",
  USER_FOLLOWING_RESPONSE: "USER_FOLLOWING_RESPONSE",
  USER_FOLLOWING_ERROR: "USER_FOLLOWING_ERROR",
};
export const USER_FOLLOWED_ACTION = {
  USER_FOLLOWED_REQUEST: "USER_FOLLOWED_REQUEST",
  USER_FOLLOWED_RESPONSE: "USER_FOLLOWED_RESPONSE",
  USER_FOLLOWED_ERROR: "USER_FOLLOWED_ERROR",
};
export const USER_UNFOLLOWING_ACTION = {
  USER_UNFOLLOWING_REQUEST: "USER_UNFOLLOWING_REQUEST",
  USER_UNFOLLOWING_RESPONSE: "USER_UNFOLLOWING_RESPONSE",
  USER_UNFOLLOWING_ERROR: "USER_UNFOLLOWING_ERROR",
};

export const PROFILE_IMAGE_ACTION = {
  PROFILE_IMAGE_REQUEST: "PROFILE_IMAGE_REQUEST",
}

export const USER_DELETEMYACCOUNT_ACTIONS = {
  USER_DELETEMYACCOUNT_REQUEST: "USER_DELETEMYACCOUNT_REQUEST",
  USER_DELETEMYACCOUNT_RESPONSE: "USER_DELETEMYACCOUNT_RESPONSE",
  USER_DELETEMYACCOUNT_ERROR: "USER_DELETEMYACCOUNT_ERROR",
};
export const USER_DELETEIMAGE_ACTIONS = {
  USER_DELETEIMAGE_REQUEST: "USER_DELETEIMAGE_REQUEST",
  USER_DELETEIMAGE_RESPONSE: "USER_DELETEIMAGE_RESPONSE",
  USER_DELETEIMAGE_ERROR: "USER_DELETEIMAGE_ERROR",
};

